import { render, staticRenderFns } from "./CookiePolicy.html?vue&type=template&id=0b00e23f&scoped=true&"
import script from "./CookiePolicy.ts?vue&type=script&lang=ts&"
export * from "./CookiePolicy.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/cookie/_cookie-policy.scss?vue&type=style&index=0&id=0b00e23f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00e23f",
  null
  
)

export default component.exports